import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function ProductBreakdown() {
  const contents = [{
    title: 'Guía Principal',
    desc: 'Toda la información clara y sin vueltas sobre qué es el hígado graso y cómo revertirlo desde la alimentación.'
  }, {
    title: 'Recetario Completo',
    desc: 'Desayunos, almuerzos, meriendas y cenas fáciles de preparar, ricas y seguras para tu hígado.'
  }, {
    title: 'Menú de 7 Días',
    desc: 'Un plan paso a paso para que no tengas que pensar qué cocinar durante tu primera semana.'
  }, {
    title: 'Lista de Compras',
    desc: 'Para que vayas al supermercado sabiendo exactamente qué llevar y qué evitar.'
  }, {
    title: 'Tabla de Reemplazos',
    desc: 'Aprendé a sustituir tus ingredientes favoritos por versiones más saludables sin perder sabor.'
  }];
  return <section className="py-24 bg-[#FAF8F3]" data-id="element-127">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-129">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-display font-bold text-stone-900 mb-6" data-id="element-130">
            ¿Qué incluye{' '}
            <span className="text-brand-600" data-id="element-131">Chau Hígado Graso</span>?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-stone-600 leading-relaxed" data-id="element-132">
            Es una guía práctica para saber qué cocinar, qué reemplazar y cómo
            organizar tus comidas cuando querés cuidar tu hígado de verdad.
          </motion.p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-133">
          {/* Product Preview (Mockups) */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-134">
            {/* Background decorative blob */}
            <div className="absolute inset-0 bg-brand-200 rounded-full blur-3xl opacity-30 transform -translate-x-10 translate-y-10" data-id="element-135"></div>

            <div className="relative z-10 grid grid-cols-2 gap-4" data-id="element-136">
              <div className="space-y-4 mt-8" data-id="element-137">
                <div className="bg-white p-2 rounded-2xl shadow-xl border border-stone-100 aspect-[3/4] overflow-hidden relative group" data-id="element-138">
                  <img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-4.0.3&fit=crop&fm=webp&w=400&q=80" alt="Recetas saludables" width={800} height={1067} loading="lazy" decoding="async" className="w-full h-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105" data-id="element-139" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4 rounded-xl" data-id="element-140">
                    <span className="text-white font-medium" data-id="element-141">
                      Recetas Fáciles
                    </span>
                  </div>
                </div>
                <div className="bg-white p-2 rounded-2xl shadow-xl border border-stone-100 aspect-square overflow-hidden relative group" data-id="element-142">
                  <img src="https://images.unsplash.com/photo-1512621776951-a57141f2eefd?ixlib=rb-4.0.3&fit=crop&fm=webp&w=400&q=80" alt="Menú saludable" width={800} height={800} loading="lazy" decoding="async" className="w-full h-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105" data-id="element-143" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4 rounded-xl" data-id="element-144">
                    <span className="text-white font-medium" data-id="element-145">
                      Menú de 7 Días
                    </span>
                  </div>
                </div>
              </div>
              <div className="space-y-4" data-id="element-146">
                <div className="bg-white p-2 rounded-2xl shadow-xl border border-stone-100 aspect-[3/4] overflow-hidden relative group" data-id="element-147">
                  <img src="https://cdn.magicpatterns.com/uploads/4Ny9LRpZayDCdVAtHZKUX3/Captura_de_pantalla_2026-06-16_a_la(s)_1.58.54_p._m..png" alt="Libro Chau Hígado Graso" width={800} height={1067} loading="lazy" decoding="async" className="w-full h-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105" data-id="element-148" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4 rounded-xl" data-id="element-149">
                    <span className="text-white font-medium" data-id="element-150">
                      Guía Principal
                    </span>
                  </div>
                </div>
                <div className="bg-white p-2 rounded-2xl shadow-xl border border-stone-100 aspect-square overflow-hidden relative group" data-id="element-151">
                  <img src="https://images.unsplash.com/photo-1542838132-92c53300491e?ixlib=rb-4.0.3&fit=crop&fm=webp&w=400&q=80" alt="Lista de compras" width={800} height={800} loading="lazy" decoding="async" className="w-full h-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105" data-id="element-152" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4 rounded-xl" data-id="element-153">
                    <span className="text-white font-medium" data-id="element-154">
                      Lista de Compras
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Product Breakdown (List) */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-155">
            {contents.map((item, i) => <div key={i} className="flex gap-4" data-id="element-156">
                <div className="flex-shrink-0 mt-1" data-id="element-157">
                  <CheckCircle2Icon className="w-6 h-6 text-brand-500" data-id="element-158" />
                </div>
                <div data-id="element-159">
                  <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-160">
                    {item.title}
                  </h3>
                  <p className="text-stone-600 leading-relaxed" data-id="element-161">{item.desc}</p>
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}